/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{watchedSignal as e}from"@lexical/extension/watchedSignal";const t={build:t=>e(()=>t.getRootElement(),e=>t.registerRootListener(t=>{e.value=t})),name:"@lexical/extension/RootElement"};export{t as RootElementExtension};
